import React from "react";
import PrimaryButton from "../Buttons/PrimaryButton";
import SubmitButton from "../Buttons/SubmitButton";

const Step2 = ({ register, errors, prevStep, nextStep }) => {
  return (
    <>
      {/* 2ème étape : Date d'effet du contrat */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium mb-2">
          Date d'effet <span className="text-red-500">*</span>
        </label>
        <input
          type="date"
          id="startDate"
          min={new Date().toISOString().split("T")[0]} // Définit la date minimale à aujourd'hui
          {...register("startDate", {
            required: "La date d'effet est obligatoire",
          })}
          className={`py-3 px-4 block w-full border ${
            errors.startDate ? "border-red-500" : "border-gray-300"
          } rounded-lg text-sm`}
        />
        {errors.startDate && (
          <p className="text-red-500">{errors.startDate.message}</p>
        )}
      </div>

      <div>
        <label htmlFor="category" className="block text-sm font-medium mb-2">
          Catégorie <span className="text-red-500">*</span>
        </label>
        <select
          id="category"
          {...register("category", {
            required: "La catégorie est obligatoire",
          })}
          className="py-3 px-4 pe-9 block w-full border border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"
        >
          <option value="">Sélectionnez une catégorie</option>
          <option value="cat1">Catégorie 1</option>
          <option value="cat2">Catégorie 2</option>
          <option value="cat3">Catégorie 3</option>
        </select>
        {errors.category && (
          <p className="text-red-500">{errors.category.message}</p>
        )}
      </div>

      <div className="mt-4 flex justify-between">
        <PrimaryButton label={"Précédent"} onClick={prevStep} />
        <SubmitButton label={"Suivant"} onClick={nextStep} />
      </div>
    </>
  );
};

export default Step2;
